import { Button, IconButton } from "@mui/joy";
import { Phone } from "@phosphor-icons/react";
import { useCall } from "../../../app/CallProvider";

export function ProfileButtonPhone({ id = 0, firstName, lastName, avatar, disabled = false }) {
    const { startCall } = useCall();

    return (
        <IconButton
            onClick={() => startCall({ id, firstName, lastName, avatar })}
            color="primary"
            variant="soft"
            sx={(theme) => ({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '2px',
                px: 2,
                py: 1,
                borderRadius: "999px",
                width: '56px',
                color: theme.palette.mode === 'dark'
                    ? theme.palette.primary[100]
                    : null,
                fontSize: '12px',
                '& svg': {
                    width: '24px',
                    height: '24px',
                }
            })}
            disabled={disabled}
        >
            <Phone size={24} />
        </IconButton>
    )
}
